/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { useQueryResponseLoading, useQueryResponsePagination } from '../../core/QueryResponseProvider'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { PaginationState } from '../../../../../../../_metronic/helpers'
import React, { useEffect, useMemo, useState } from 'react'
import ReactPaginate from 'react-paginate'

const mappedLabel = (label: string): string => {
  if (label === '&laquo; Previous') {
    return 'Previous'
  }

  if (label === 'Next &raquo;') {
    return 'Next'
  }


  return label
}

const UsersListPagination = ({ initialApi }: any) => {
  const pagination = useQueryResponsePagination()
  const isLoading = useQueryResponseLoading()
  const { updateState, state } = useQueryRequest()
  const [options, setOptions] = useState([state.size])
  // const updatePage = (page: number | undefined | null) => {
  //   if (!page || isLoading || pagination.page === page) {
  //     return
  //   }
  //   updateState({page, size: pagination.size || 10})
  // }
  useEffect(() => {
    if (pagination.totalItems) {
      const generateOptions = (total: number): number[] => {
        const baseOptions: number[] = [10, 50, 100, 200, 300, 500, 800, 1100]
        let filteredOptions: number[] = []
        // Add options that are less than or equal to totalItems
        for (let i = 0; i < baseOptions.length; i++) {
          if (baseOptions[i] <= total) {
            filteredOptions.push(baseOptions[i])
          } else {
            // If the current option exceeds totalItems, add the next higher option if applicable
            if (filteredOptions.length > 0) {
              filteredOptions.push(baseOptions[i]) // Add the next higher option
            }
            break // Stop the loop
          }
        }

        return filteredOptions
      }

      const dynamicOptions = generateOptions(pagination.totalItems)
      if (dynamicOptions.length) {
        setOptions(dynamicOptions)
      }
    }
  }, [pagination])

  const handlePagination = (page: number) => {
    if (isLoading) {
      return
    }
    updateState({ page: page - 1, ...((initialApi && { initialApi }) || {}) })
  }
  const handlePerPage = (event: any) => {
    const perPage = event.target.value
    if (isLoading) {
      return
    }
    updateState({ size: perPage, ...((initialApi && { initialApi }) || {}) })
  }
  // Calculate showing text
  const startItem = (state.page || 0) * (state.size || 10) + 1;
  const endItem = Math.min(((state.page || 0) + 1) * (state.size || 10), pagination.totalItems || 0);
  const totalItems = pagination.totalItems || 0;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '24px', padding: '10px 0', borderTop: '1px solid #EEF0F3', paddingTop: '20px' }}>

      {/* Showing N to M of Total */}
      <div style={{ color: '#7E8299', fontSize: '13px', fontWeight: '500' }}>
        Showing {totalItems > 0 ? startItem : 0} to {endItem} of {totalItems} results
      </div>

      {/* Pagination Controls */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>

        {/* React Paginate wrapper */}
        {pagination.totalPages > 0 && (
          <div className="custom-pagination-wrapper">
            <style>{`
               .custom-pagination-wrapper .pagination {
                 display: flex;
                 list-style: none;
                 padding: 0;
                 margin: 0;
                 gap: 8px;
                 align-items: center;
               }
               .custom-pagination-wrapper .pagination li a {
                 display: flex;
                 align-items: center;
                 justify-content: center;
                 min-width: 34px;
                 height: 34px;
                 padding: 0 8px;
                 border-radius: 8px;
                 background-color: #ffffff;
                 border: 1px solid #E4E6EF;
                 color: #3F4254;
                 font-size: 13px;
                 font-weight: 600;
                 cursor: pointer;
                 text-decoration: none;
                 transition: all 0.2s ease;
               }
               .custom-pagination-wrapper .pagination li.active a {
                 background-color: #FFE500;
                 border-color: #FFE500;
                 color: #000000;
               }
               .custom-pagination-wrapper .pagination li:not(.active):not(.disabled) a:hover {
                 background-color: #F9F9F9;
                 border-color: #3699FF;
               }
               .custom-pagination-wrapper .pagination li.disabled a {
                 opacity: 0.5;
                 cursor: not-allowed;
                 background-color: #F9F9F9;
               }
               .custom-pagination-wrapper .pagination li.previous a,
               .custom-pagination-wrapper .pagination li.next a {
                 font-weight: bold;
                 color: #7E8299;
               }
             `}</style>
            <ReactPaginate
              nextLabel={<span style={{ fontSize: '16px', lineHeight: 1 }}>&rsaquo;</span>}
              previousLabel={<span style={{ fontSize: '16px', lineHeight: 1 }}>&lsaquo;</span>}
              breakLabel={'...'}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              activeClassName={'active'}
              breakClassName={'break-me'}
              containerClassName={'pagination'}
              disabledLinkClassName={'disabled'}
              onPageChange={(page: any) => handlePagination(page.selected + 1)}
              pageCount={pagination.totalPages}
              forcePage={state.page || 0}
            />
          </div>
        )}

        {/* Per Page Selector */}
        {pagination.totalPages > 0 && (
          <div style={{ position: 'relative' }}>
            <select
              value={state.size}
              onChange={(e: any) => handlePerPage(e)}
              style={{
                padding: '8px 30px 8px 12px',
                border: '1px solid #E4E6EF',
                borderRadius: '8px',
                backgroundColor: '#ffffff',
                color: '#3F4254',
                fontSize: '13px',
                fontWeight: '600',
                outline: 'none',
                appearance: 'none',
                cursor: 'pointer',
              }}
            >
              {options.map((option) => (
                <option key={option} value={option}>
                  {option} per page
                </option>
              ))}
            </select>
            <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#A1A5B7' }}>
              <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>
        )}

      </div>
    </div>
  )
}

export { UsersListPagination }
